import React from 'react'

import { Modal } from '@/shared/ui'

import styles from './basket-remove-modal.module.scss'

type BasketRemoveModalProps = {
	open: boolean
	onCancel: () => void
	onOk: () => void
	okText?: string
	cancelText?: string
}

/** A modal window for removing products from the basket on mobile.
 *  @param props
 * */
export const BasketRemoveModal = ({
	open,
	onCancel,
	onOk,
	okText,
	cancelText
}: BasketRemoveModalProps): JSX.Element => {
	return (
		<Modal
			isOpen={open}
			onClose={onCancel}
			onOk={onOk}
			okText={okText}
			cancelText={cancelText}
			contentClassName={styles.modal}>
			<h5 className={styles.title}>Удаление товаров</h5>
			<p className={styles.description}>
				Вы точно хотите удалить выбранные товары? Отменить действие будет невозможно.
			</p>
		</Modal>
	)
}
